import {Component, Input, OnInit} from '@angular/core';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {Activity} from '@shared/models/activity';
import {Post} from '@shared/models/post';
import {Picture} from '@core/services/picture';
import {AppTeam} from '@shared/models/team';
import {IVideo} from '@api/models/video/video';
import {UserService} from '@core/services/user.service';
import {LibVideoPlayerService} from '@components/video-player/services/lib-video-player.service';
import {SubscriptionTrackingInfo} from '@lib/models/subscription/subscription-tracking-info';
import {SubscriptionContentType} from '@lib/models/subscription/subscription-content-type';
import {SubscriptionIdType} from '@lib/models/subscription/subscription-id-type';

@Component({
  selector: 'app-match-live-ticker-activity',
  templateUrl: './match-live-ticker-activity.component.html',
  styleUrls: ['./match-live-ticker-activity.component.scss']
})
export class MatchLiveTickerActivityComponent implements OnInit {

  @Input() public isLive = false;
  @Input() public videoSource: string;
  @Input() public videos: IVideo[];
  @Input() public autoStartVideo = false;
  @Input() public post: Post;
  @Input() public activity: Activity;
  @Input() public onVideosPage = false;
  @Input() public showVertLine = true;
  @Input() public title = '';
  @Input() public timeString = '';
  public isGoal = false;
  public activityIcon: string;
  public teamImage = '';
  public text = '';
  public images: Picture[] = [];
  public videoPaywallActive = false;
  public trackingInfo: SubscriptionTrackingInfo = null;

  constructor( public matchDetailViewService: MatchDetailViewService,
               public userService: UserService,
               private videoPlayerService: LibVideoPlayerService ) { }

  public ngOnInit(): void {
    this.videoPaywallActive = this.matchDetailViewService.data?.match?.streaming_info?.paywall;
    const match = this.matchDetailViewService.data.match;
    this.videoPlayerService.paywallSettings = {
      activeTeamIds: [match.teams.home.teamid, match.teams.away.teamid],
      activeEventId: match.id,
    }
    this.setTrackingInfo();
    if (this.videoSource || this.videos?.length) {
      this.activityIcon = 'assets/icons/video-bg-blue.svg';
      this.setTeamImage(null);
      return;
    }
    this.videos = [];
    if (this.activity) {
      this.activityIcon = this.activity.symbol;
      if (this.activity.teams?.home?.teamid === this.matchDetailViewService.data.currentTeamId) {
        this.activityIcon = this.activity.teams.home.symbol;
      } else if (this.activity.teams?.away?.teamid === this.matchDetailViewService.data.currentTeamId) {
        this.activityIcon = this.activity.teams.away.symbol;
      }
      this.timeString = this.activity.display_minute;
      this.title = this.activity.title;
      this.text = this.activity.text;
      this.images = this.activity.otherImages;
      if (this.activity.videos_native?.length > 0) {
        this.videos = this.activity.videos_native;
      } else if (this.activity.video?.video_url) {
        this.videos.push({
          url: this.activity.video.video_url,
          preview_url: this.activity.video.preview_url,
          paywall: false,
        } as IVideo);
      }
      this.setTeamImage(this.activity.teamid);
      return;
    }

    if (this.post) {
      this.activityIcon = this.post.symbol;
      if (this.post.videos_native?.length > 0) {
        this.videos = this.post.videos_native;
      }
      this.timeString = this.post.display_minute;
      this.title = this.post.title;
      this.text = this.post.text;
      this.images = this.post.otherImages;
      this.setTeamImage(this.post.teamid);
    }
  }

  private setTrackingInfo() {
    if (!this.activity) {
      return;
    }
    this.trackingInfo = {
      contentType: SubscriptionContentType.ACTIVITY,
      idType: SubscriptionIdType.ACTIVITY_ID,
      id: this.activity._id,
    }
  }

  public hasMedia(): boolean {
    return this.videos?.length > 0 || this.images?.length > 0;
  }

  private setTeamImage(teamId: string) {
    let team: AppTeam = null;

    if (!this.matchDetailViewService.data || !this.matchDetailViewService.data.match) {
      return;
    }

    switch (teamId) {
      case this.matchDetailViewService.data.homeTeam.id:
        team = this.matchDetailViewService.data.homeTeam;
        break;
      case this.matchDetailViewService.data.awayTeam.id:
        team = this.matchDetailViewService.data.awayTeam;
        break;
    }

    if (team) {
      this.teamImage = team.getLogoImageUrl('big');
    }
  }

  index(obj, is, value = undefined) {
    if (typeof is === 'string') {
      return this.index(obj, is.split('.'), value);
    } else if (is.length === 1 && value !== undefined) {
      return obj[is[0]] = value;
    } else if (is.length === 0) {
      return obj;
    } else {
      return this.index(obj[is[0]], is.slice(1), value);
    }
  }
}
